import { setTerm } from './helpers';

export const setFromDeveloper = setTerm('from_developer');
